import { render, staticRenderFns } from "./todo-tab3.vue?vue&type=template&id=473733a8&"
import script from "./todo-tab3.vue?vue&type=script&lang=ts&"
export * from "./todo-tab3.vue?vue&type=script&lang=ts&"
import style0 from "./todo-tab3.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports